export const minLength = (length, msg) => {
    return (value) => (!value || value.length >= length ? null : msg);
};
